<template>
  <div ref="wrapper">
    <!-- <div class="container"> -->
    <slot></slot> <!--分发内容-->
    <!-- <div v-if="pullupTxt" class="pullup"> -->
    <!-- <div class="clear" v-if="!isDone">
      <div class="fl"><img width="30" src="../../assets/images/checks.png"></div>
      <div class="fl lh30 ml10">加载中.....</div>
    </div> -->
    <!-- <div class="list-donetip" v-if="!data">
      <slot name="doneTip">没有数据了</slot>
    </div> -->
    <!-- </div> -->
    <!-- </div> -->
  </div>
</template>
<script >
import BScroll from 'better-scroll' // 引入better-scroll
// 详细参数可以了解better-scroll的文档 https://blog.csdn.net/weixin_37719279/article/details/82084342
export default {
  name: 'PCScroll',
  props: {
    probeType: { // probeType 为 3 的时候，不仅在屏幕滑动的过程中，而且在 momentum 滚动动画运行过程中实时派发 scroll 事件。
      type: Number,
      default: 3
    },
    click: { // better-scroll 默认会阻止浏览器的原生 click 事件。当设置为 true，better-scroll 会派发一个 click 事件，我们会给派发的 event 参数加一个私有属性 _constructed，值为 true。
      type: Boolean,
      default: true
    },
    listenScroll: { // 是否监听scroll事件，如果为true，需在父组件中加入对应监听的方法名，对应methods中emit提交
      type: Boolean,
      default: false
    },
    data: {}, // 传入数据，注意没有对类型做限制，未设置默认值
    pullup: {
      type: Boolean,
      default: false
    }, // 上拉加载更多，传入非false值为开启上拉加载，false为不开启
    pullupTxt: {
      type: Boolean,
      default: false
    },
    refreshDelay: { // 数据刷新延迟时间
      type: Number,
      default: 20
    },
    swipeBounceTime: { // 设置当运行 momentum 动画时，超过边缘后的回弹整个动画时间。
      type: Number,
      default: 800
    },
    momentumLimitTime: { // 在屏幕上快速滑动的时间小于 momentumLimitTime，才能开启 momentum 动画。
      type: Number,
      default: 200
    },
    bounceTime: { // 设置回弹动画的动画时长。
      type: Number,
      default: 300
    },
    bounce: {
      type: Boolean,
      default: true
    },
    startX: { // 纵轴方向初始化位置
      type: Number,
      default: 0
    },
    startY: { // 纵轴方向初始化位置
      type: Number,
      default: 0
    },
    scrollbar: {
      type: Boolean,
      default: false
    },
    wheel: {},
    mouseWheel: {
      type: Boolean,
      default: false
    },
    eventPassthrough: {
      type: [String, Boolean],
      default: null
    },
    scrollY: {
      type: Boolean,
      default: true
    },
    scrollX: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      dragTip: {
        text: '下拉刷新',
        translate: -50,
        showLoding: false
      },
      isLoading: false,
      isDone: false
    }
  },
  watch: {
    data: {
      immediate: true,
      handler: function () {
        setTimeout(() => {
          this.refresh()
        }, this.refreshDelay)
      }
    }
    // data () {
    //   setTimeout(() => {
    //     this.refresh()
    //   }, this.refreshDelay)
    // }
  },
  // updated () {
  //   this.$nextTick(() => {
  //     this._initScroll()
  //   })
  // },
  mounted () {
    setTimeout(() => {
      this._initScroll()
    }, 25)
  },
  methods: {
    _initScroll () {
      if (!this.$refs.wrapper) {
        return
      }
      this.scroll = new BScroll(this.$refs.wrapper, {
        probeType: this.probeType,
        click: this.click,
        swipeBounceTime: this.swipeBounceTime,
        bounceTime: this.bounceTime,
        momentumLimitTime: this.momentumLimitTime,
        scrollY: this.scrollY,
        scrollX: this.scrollX,
        startX: this.startX,
        startY: this.startY,
        scrollbar: this.scrollbar,
        mouseWheel: this.mouseWheel ? {
          SPEED: 20,
          easeTime: 300,
          invert: false
        } : false,
        wheel: false,
        pullUpLoad: {
          threshold: 30
        },
        bounce: this.bounce,
        eventPassthrough: this.eventPassthrough
      })
      this.$emit('setScroll', this.scroll)
      if (this.listenScroll) {
        const me = this
        this.scroll.on('scroll', (pos) => {
          me.$emit('scroll', pos)
        })
      }
      if (this.pullup) {
        // this.scroll.on('scrollEnd', () => {
        //   if (this.scroll.y <= (this.scroll.maxScrollY + 10)) {
        //     // 所有数据加载完毕后
        //     this.$on('infinitescroll.loadedDone', () => {
        //       this.isLoading = false
        //       this.isDone = true
        //     })
        //     // 单次请求数据加载完毕后
        //     this.$on('infinitescroll.finishLoad', (ret) => {
        //       this.isLoading = false
        //     })
        //     // 重新初始化
        //     this.$on('infinitescroll.reInit', () => {
        //       this.isLoading = false
        //       this.isDone = false
        //     })
        //     // this.$emit('scrollToEnd')
        //   }
        // })
        this.scroll.on('pullingUp', () => {
          this.$emit('pullup', this.scroll)
          this.isLoading = false
          this.isDone = true
          this.scroll.finishPullUp()
        })
      }
      if (this.beforeScroll) {
        this.scroll.on('beforeScrollStart', () => {
          this.$emit('beforeScroll')
        })
      }
    },
    disable () {
      this.scroll && this.scroll.disable()
    },
    enable () {
      this.scroll && this.scroll.enable()
    },
    refresh () {
      this.scroll && this.scroll.refresh()
    },
    scrollTo () { // 滚动到指定位置
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments)
    },
    scrollToElement () { // 滚动到指定的目标元素。
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments)
    },
    pullupLoadMore () {
      const tip = document.querySelector('.loading-hook')
      tip.innerText = 'loading...'
      this.isLoading = true
      setTimeout(() => {
        if (!this.flag) {
          tip.innerText = '查看更多'
          this.$emit('getDate')
        } else {
          tip.innerText = '没有更多数据了^_^'
        }
        this.isLoading = false
      }, 1000)
    }
  }
}
</script>
<style scoped >
.wrapper {
  height: 100%;
  overflow: hidden;
}
.container {
  overflow: hidden;
}
.pulldown, .pullup {
  width: 100%;
  height: 50px;
  position: relative;
}
div.clear {
  padding:10px 0px;
  font-size:.28rem;
  position:absolute;
  left:50%;
  top:5px;
  transform:translate(-50%,0);
}
.list-donetip {
  text-align:center;
  line-height:50px;
  font-size:.28rem;
}
</style>
